import FaqFolderView from 'design-comuni-plone-theme/components/ItaliaTheme/View/FAQ/FaqFolder/FaqFolderView';
import OffertaLavoroView from './components/View/OffertaLavoroView/OffertaLavoroView';
import AccessiWay from './components/AccessiWay/AccessiWay';
import {
  addSimpleCardTemplateOptions,
  addLinkMoreOptions,
} from 'design-comuni-plone-theme/config/Blocks/ListingOptions';

const changeDefaultValuesTemplateOptions = (
  values = {},
  schema,
  groupName = 'default',
) => {
  Object.keys(values).forEach((f) => {
    schema.properties[f].default = values[f];
  });
};

const applyConfig = (config) => {
  config.settings = {
    ...config.settings,
    // italiaThemeViewsConfig: {
    //   ...config.settings.italiaThemeViewsConfig,
    //   imagePosition: 'afterHeader', // possible values: afterHeader, documentBody
    // },
    siteProperties: {
      /*
        Per tutte le props di siteProperties, può essere definito un oggetto per i siti multilingua, strutturato in questo modo:
        {'default': _valore_della_prop, 'it': _valore_della_prop,...}
        Se l'oggetto non è strutturato in questo modo, viene usato l'oggetto stesso, altrimenti viene preso il valore della corrispondente alla prop della lingua corrente o alla prop 'default' se esiste.
      */
      ...config.settings.siteProperties,
      siteTitle: undefined,
      siteSubtitle: undefined,
      subsiteParentSiteTitle: undefined,
      parentSiteTitle: 'Regione Lombardia',
      parentSiteURL:
        'https://www.regione.lombardia.it/wps/portal/istituzionale/',
      footerNavigationDepth: 1, //valori possibili: [1,2]. Se impostato ad 1 non verranno mostrati nel footer i link agli elementi contenuti nelle sezioni di primo livello.
    },

    'volto-repeatable-content-block': {
      ...config.settings['volto-repeatable-content-block'],
      renderer: {
        ...(config.settings['volto-repeatable-content-block']?.renderer ?? {}),

        FaqFolder: FaqFolderView, //componente per renderizzare l'oggetto tipo FaqFolder
      },
    },
  };

  config.settings['volto-blocks-widget'].allowedBlocks = [
    ...config.settings['volto-blocks-widget'].allowedBlocks,
    'listing',
  ];

  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    OffertaLavoro: OffertaLavoroView,
  };

  config.settings['volto-gdpr-privacy'].defaultPanelConfig = null;

  // TODO: questo andrà tolto quando sarà risolto il problema su dvpt/volto
  config.settings.querystringAdditionalFields = [
    ...(config.settings.querystringAdditionalFields || []),
    'fullobjects',
  ];
  config.settings.appExtras = [
    ...(config.settings.appExtras || []),
    {
      match: '',
      component: AccessiWay,
    },
  ];

  config.blocks.blocksConfig.listing.variations.find(
    (v) => v.id === 'simpleCard',
  ).schemaEnhancer = ({ schema, formData = {}, intl }) => {
    schema.properties.always_show_image = {
      type: 'boolean',
      default: true,
    };
    schema.fieldsets[0].fields.push('always_show_image');
    schema.properties.show_topics = {
      type: 'boolean',
      default: false,
    };

    addSimpleCardTemplateOptions(schema, formData, intl);
    addLinkMoreOptions(schema, formData, intl);

    const overrideDefaults = {
      show_description: true,
      show_icon: false,
      hide_dates: false,
      show_section: false,
      show_type: false,
      show_detail_link: false,
      show_path_filters: false,
      always_show_image: true,
      show_topics: false,
    };

    Object.entries(overrideDefaults).forEach(([key, value]) => {
      if (schema.properties?.[key]) {
        schema.properties[key].default = value;
      }
    });

    return schema;
  };

  return config;
};

export default applyConfig;
